import { View } from 'backbone';
import Environment from '../environment';
import { getLogger } from '../logging/logger';
import { wait } from '../util/utilities';
import Alert from './alert';

const logger = getLogger('Alerts');

class Alerts extends View {
	id() {
		return 'alerts';
	}

	className() {
		return 'alerts';
	}

	/** @returns {Number} Default duration that an alert will be displayed */
	get alertDuration() {
		return 8000;
	}

	/**
	 * Displays an alert on screen.
	 * @param {import('./alert').AlertType} type The type of alert to display.
	 * @param {String} message The message to put in the alert.
	 * @param {Number} [duration] The amount of time in MS to display the alert for.
	 */
	show(type, message, duration) {
		logger.log('[show]', { type, message, duration });

		if (!Environment.isDev() && !Environment.isLocal()) {
			console.warn('Alerts disabled outside of Dev or Local');
			return;
		}

		const alert = new Alert({ type, message });
		this.$el.append(alert.el);

		wait(duration || this.alertDuration).then(() =>
			alert.$el.fadeOut(0, alert.$el.remove.bind(alert.$el)),
		);
	}

	/**
	 * Displays an 'info' alert.
	 * @param {String} message The message to show in an 'info' alert.
	 * @param {Number} [duration] The amount of time in MS that the alert will display be displayed for.
	 */
	info(message, duration) {
		logger.log('[info]', { message, duration });

		this.show('info', message, duration);
	}

	/**
	 * Displays an 'success' alert.
	 * @param {String} message The message to show in an 'info' alert.
	 * @param {Number} [duration] The amount of time in MS that the alert will display be displayed for.
	 */
	success(message, duration) {
		logger.log('[success]', { message, duration });

		this.show('success', message, duration);
	}

	/**
	 * Displays an 'danger' alert.
	 * @param {String} message The message to show in an 'info' alert.
	 * @param {Number} [duration] The amount of time in MS that the alert will display be displayed for.
	 */
	danger(message, duration) {
		logger.log('[danger]', { message, duration });

		this.show('danger', message, duration);
	}

	/**
	 * Clears alerts that are currently on screen
	 */
	clear() {
		this.$el.empty();
	}
}

export default new Alerts();
